<template>
  <div>
    <div class="uren-slider_area uren-slider_area-2">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-3 col-lg-4">
          <Categories />
          </div>


          <div class="col-xl-9 col-lg-8">
              <VueSlickCarousel v-bind="settingsCarousel" class="main-slider slider-navigation_style-2">
                <!-- Begin Single Slide Area -->
                <div class="single-slide animation-style-01 bg-3">
                  <div class="slider-content">
                    <span>Best tools for a better job</span>
                    <h3>Screwdriver</h3>
                    <h4>Starting at <span>$30.00</span></h4>
                    <div class="uren-btn-ps_left slide-btn">
                      <a class="uren-btn" href="shop-left-sidebar.html">Read More</a>
                    </div>
                  </div>
                </div>
                <!-- Single Slide Area End Here -->
                <!-- Begin Single Slide Area -->
                <div class="single-slide animation-style-02 bg-4">
                  <div class="slider-content slider-content-2">
                    <span class="primary-text_color">Better tools</span>
                    <h3>Happy Team</h3>
                    <h4>Sale up to 20% off</h4>
                    <div class="uren-btn-ps_left slide-btn">
                      <a class="uren-btn" href="shop-left-sidebar.html">Read More</a>
                    </div>
                  </div>
                </div>

                <template #prevArrow>
                  <button class="slick-prev"><i class="ion-ios-arrow-back"></i></button>
                </template>
                <template #nextArrow>
                  <button class="slick-next"><i class="ion-ios-arrow-forward"></i></button>
                </template>
              </VueSlickCarousel>
          </div>

        </div>
      </div>
    </div>
   
   <!-- New Arrivals Products  -->
    <new-arrivals />
       

    <!-- Speical Offers  -->
    <special-offers />

    
    <!-- Brands  -->
   <brands />

  </div>
</template>

<script>
import Categories from '../../components/Categories.vue';
import Brands from './components/Brands.vue';
import NewArrivals from './components/NewArrivals.vue';
import SpecialOffers from './components/SpecialOffers.vue';
import Form from "vform";

export default {
  name: 'Home',
  data() {
    return {
      settingsCarousel: {
        infinite: true,
        autoplay: true,
        fade: true,
        dots: true,
        autoplaySpeed: 7000,
        speed: 1000,
        adaptiveHeight: true,
        easing: "ease-in-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    }
  },
  components: {
    Categories,
    NewArrivals,
    SpecialOffers,
    Brands,
  },
}
</script>